import { init } from "./adapters/init";

/**
 * Starts telemetry. The composition root: the app entry files call this at
 * module scope, before React exists, and nothing else does.
 *
 * Kept apart from the facade because init needs the telemetry level, its
 * store and (on web) the consent and network helpers, and the facade must not
 * import those (see `index.ts`).
 */
export const initTelemetry = (): void => {
  try {
    init();
  } catch (error) {
    // Starting telemetry must never stop the app starting.
    // eslint-disable-next-line no-console
    console.error("Error starting DataDog", error);
  }
};
